import { observer } from 'mobx-react';
import { FC, useEffect, useMemo } from 'react';
import CheckoutAddress from '../../components/CheckoutAddress/CheckoutAddress';
import CheckoutBranches from '../../components/CheckoutBranches/CheckoutBranches';
import CheckoutCustomerInfo from '../../components/CheckoutCustomerInfo/CheckoutCustomerInfo';
import CheckoutCustomerMobile from '../../components/CheckoutCustomerMobile/CheckoutCustomerMobile';
import CheckoutDeliveryType from '../../components/CheckoutDeliveryType/CheckoutDeliveryType';
import CheckoutDueTime from '../../components/CheckoutDueTime/CheckoutDueTime';
import CheckoutNotes from '../../components/CheckoutNotes/CheckoutNotes';
import OrderCurbside from '../../components/OrderCurbside/OrderCurbside';
import OrderDineIn from '../../components/OrderDineIn/OrderDineIn';
import OrderForSomeoneElse from '../../components/OrderForSomeoneElse/OrderForSomeoneElse';
import { useCheckoutStoreContext } from '../../context';
import { deliveryTypeStore } from 'src/view/screens/DeliveryTypeScreen/store/deliveryTypeStore';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import { ORDER_EDIT_STAGE } from 'src/mobx/checkoutStore/constants';
import { appStore } from 'src/mobx/appStore';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import CheckoutZones from '../../components/CheckoutZones/CheckoutZones';
import CheckoutAddresses from '../../components/CheckoutAddresses/CheckoutAddresses';

const CustomerDetailsTab: FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  useEffect(() => {
    checkoutStore.validate();
  }, []);

  /**
   * Show Order For Someone Else
   */
  const isNoDonationItems = useMemo((): boolean => {
    return !checkoutStore.dependencies.products.some((item) => item.is_donation);
  }, [checkoutStore.dependencies.products]);

  const isCurbside = useMemo(
    () => !checkoutStore.params.is_order_for_someone_else && checkoutStore.params.is_curbside,
    [checkoutStore.params.is_order_for_someone_else, checkoutStore.params.is_curbside]
  );

  return (
    <div className="d-flex flex-1 full-width pt-4">
      {/* indicator for checking address of last order of user after selecting user */}
      <LoadingOverlay visible={deliveryTypeStore.loading} refreshing />
      <div className="d-flex flex-column full-width">
        {/* customer mobile */}
        <CheckoutCustomerMobile />
        {/* branches picker default */}
        {(!appStore.settings?.is_cc_zone_orders || checkoutStore.params.delivery_type !== DELIVERY_TYPE.DELIVERY) && <CheckoutBranches />}
        {/* delivery type */}
        <CheckoutDeliveryType />
        {appStore.settings?.is_cc_zone_orders && checkoutStore.params.delivery_type === DELIVERY_TYPE.DELIVERY ? (
          <>
            {/* zone picker*/}
            <CheckoutZones />
            {/* address picker */}
            <CheckoutAddresses />
            {/* branches picker cc_zone_orders */}
            <CheckoutBranches />
          </>
        ) : null}
        {/* asap/ahead and dateTime picker */}
        <CheckoutDueTime />
        {/* customer name and email */}
        <CheckoutCustomerInfo />
        {/* order notes */}
        {checkoutStore.orderEditStage === ORDER_EDIT_STAGE.CHECKOUT ? <CheckoutNotes /> : null}
        {/* address */}
        {!appStore.settings?.is_cc_zone_orders &&
        checkoutStore.orderEditStage === ORDER_EDIT_STAGE.CHECKOUT &&
        checkoutStore.params.delivery_type === DELIVERY_TYPE.DELIVERY ? (
          <CheckoutAddress />
        ) : null}
        {/* curbside */}
        {isCurbside ? <OrderCurbside checkoutStore={checkoutStore} /> : null}
        {/* dine-in */}
        {checkoutStore.params.is_dinein ? <OrderDineIn /> : null}
        {/* order for someone else */}
        {appStore.settings?.allow_order_for_else && isNoDonationItems ? <OrderForSomeoneElse /> : null}
      </div>
    </div>
  );
});

export default CustomerDetailsTab;
